import { useMemo } from "react";

import { Select } from "neetoui";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { getCurrencies } from "./utils";

const Currency = ({ label, allowedCurrencies, ...otherSelectProps }) => {
  const { t } = useTranslation();

  const data = useMemo(
    () => getCurrencies(allowedCurrencies),
    [allowedCurrencies]
  );

  return (
    <Select
      label={label || t("neetoMolecules.common.currency")}
      options={data}
      {...otherSelectProps}
    />
  );
};

Currency.propTypes = {
  /**
   * Label for the currency input.
   */
  label: PropTypes.string,
  /**
   * To specify only a selected list of currencies to be used.
   */
  allowedCurrencies: PropTypes.arrayOf(PropTypes.string),
};

export default Currency;
